import Protocols from '@/services/protocols'
import store from '../..'
import * as types from './mutation-types'

export const loadProtocols = async ({ commit, state }, filters) => {
   if (state.protocolsLoaded) {    
    return state.protocols
  }
  const brand = store.getters['brand/getBrand'] || {}
  const mar_id = brand.id || ''
  const default_filters = {
    mar_id,
  }

  const request_body = Object.assign({}, default_filters, filters)
  const response = await Protocols.getProtocols(request_body)
  const protocols = response.calls.length > 0 ? response.calls.sort((a, b) => {
    const dataA = new Date(a.PRT_DTCRIACAO)
    const dataB = new Date(b.PRT_DTCRIACAO)
    return dataB - dataA 
  }) : []
  
  commit(types.FILL_PROTOCOLS, { protocols })
  return protocols
}


export const loadProductBalanceB2C = async ({ commit }, filters) => {
  const response = await Protocols.getProductBalanceB2C(filters) 
  return  response?.productBalance || [] 
}

export const updateProtocolData = async ({ commit }, fields) => {
  const response = await Protocols.updateProtocolData(fields)
  return response
}
